import {ReactElement, useContext} from 'react'
import Images from '../Images'
import AppContext from '../contexts/AppContext'
import {InnerAppContext} from '../../../common/types'
import {useStyles} from './styles'

export function EmptyTableResults(): ReactElement {
  const {themePreference} = useContext(AppContext) as InnerAppContext // context has different type

  const classNames = useStyles()

  return (
    <div className={classNames.textCenter}>
      <img className={classNames.emptyListsIcon} src={Images[`documents-empty-${themePreference}.png`]} alt='noTrades' />
    </div>
  )
}
